import actions from './actions'
import mutations from './mutation'

const state = {
  crosschainrecord_list: [],
  crosschainrecord_paging: {
    offset: 0,
    limit: 10,
    total: 0
  }
}

export default {
  state,
  actions,
  mutations
}
